<template>
  <div v-if="hasPermission">
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    requiredPermission: {
      type: String,
      required: true,
    },
    requiredAction: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      userType: (state) => state.auth.user.userType,
      permissions: (state) => {
        const { user } = state.auth;
        const userPermissions = user.permissions;
        return userPermissions;
      },
    }),
    hasPermission() {
      if (this.userType === "super-admin") {
        return true;
      }
      const userPermission = this.permissions.find(
        (userPermission) =>
          userPermission.permission === this.requiredPermission
      );
      return (
        userPermission && userPermission.actions.includes(this.requiredAction)
      );
    },
  },
  // mounted() {
  //   console.log(this.permissions);
  // },
};
</script>
